import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  siteBoxDocumentsKeys,
  RequestTypes,
} from '@core/react-query/features/siteBoxDocuments'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { foldersKeys } from '../../folders'
import { ISiteBoxDocument } from '@core/entities/SiteBoxDocument'

export const useArchiveSiteBoxDocument = (
  options?: UseMutationOptions<
    ISiteBoxDocument,
    RequestErrorType,
    RequestTypes['archiveDocument']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...siteBoxDocumentsKeys.archiveDocument,
    onSuccess: (_, { documentId }) => {
      queryClient.invalidateQueries({
        queryKey: siteBoxDocumentsKeys.byId({ documentId }).queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: foldersKeys._def,
      })
    },
    ...options,
  })
}
